module.exports = __webpack_public_path__ + "static/logo-text-709bd258f4e1ecfefbac125ff15bc033.png";